// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__qf5Qs","title":"Images45_title__21pyV","images":"Images45_images__14RO0"};